import React, { useState, useEffect, useRef } from "react";

const VideoIntro = ({ onDone }) => {
  const [isVisible, setIsVisible] = useState(() => {
    try {
      if (sessionStorage.getItem("uh_intro_shown")) return false;
      return true;
    } catch {
      return true; // Show intro if sessionStorage is unavailable
    }
  });
  const [fadeOut, setFadeOut]   = useState(false);
  const videoRef                = useRef(null);

  useEffect(() => {
    // If not visible, do nothing
    if (!isVisible) return;

    const video = videoRef.current;
    if (!video) return;

    // Lock body scroll while intro plays
    document.body.style.overflow = "hidden";

    const dismiss = () => {
      setFadeOut(true);
      // Mark intro as shown in this session
      try {
        sessionStorage.setItem("uh_intro_shown", "1");
      } catch {}
      // Reset overflow immediately
      document.body.style.overflow = "";
      
      // Wait for fade animation to complete, then unmount
      setTimeout(() => {
        setIsVisible(false);
        if (onDone) onDone();
      }, 700); // matches fade-out duration
    };

    video.addEventListener("ended", dismiss);
    video.addEventListener("error", dismiss);

    // Safety fallback — dismiss after 10s no matter what
    const fallback = setTimeout(dismiss, 10000);

    return () => {
      video.removeEventListener("ended", dismiss);
      video.removeEventListener("error", dismiss);
      clearTimeout(fallback);
      document.body.style.overflow = ""; // Ensure cleanup
    };
  }, [isVisible, onDone]);

  // Don't render anything if not visible
  if (!isVisible) return null;

  return (
    <>
      <style>{`
        @keyframes uh-fade-in {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes uh-fade-out {
          from { opacity: 1; }
          to   { opacity: 0; }
        }
        .uh-intro-overlay {
          position: fixed;
          inset: 0;
          z-index: 9999;
          background: #000;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: uh-fade-in 0.4s ease forwards;
        }
        .uh-intro-overlay.fading {
          animation: uh-fade-out 0.7s ease forwards;
        }
        .uh-intro-video {
          max-width: 420px;
          width: 80vw;
          height: auto;
        }
      `}</style>

      <div className={`uh-intro-overlay${fadeOut ? " fading" : ""}`}>
        <video
          ref={videoRef}
          className="uh-intro-video"
          src="/logoanim.mp4"
          autoPlay
          muted
          playsInline
          preload="auto"
        />
      </div>
    </>
  );
};

export default VideoIntro;
